module.exports = __webpack_public_path__ + "static/media/starter-stering-and-replacement.864c27ad.svg";